
import {
    REQUEST_GET_TRAT_DETAIL,
    RESPONSE_GET_TRAT_DETAIL
} from '../actions/TratDetail';

const initialState = {
    id: -1,
    data: {},
    loading: false,
    notFound: false
};

export default function tratDetail(state = initialState, action) {
    switch (action.type) {
        case REQUEST_GET_TRAT_DETAIL:
            return {
                ...state,
                id: action.id,
                data: {},
                loading: true
            };

        case RESPONSE_GET_TRAT_DETAIL:
            return {
                ...state,
                data: action.data,
                notFound: action.data ? !action.data.attributes.id : true,
                loading: false
            };

        default:
            return state
    }
}
